import { dateDayWeeksBefore } from 'utils/dates';

const dataMethodologies = [
  {
    investorType: 'Venture Capital',
    methodology: 'EV/Revenues',
    count: 1,
    date: dateDayWeeksBefore(5, 5)
  },
  {
    investorType: 'Venture Capital',
    methodology: 'EV/EBITDA',
    count: 1,
    date: dateDayWeeksBefore(5, 5)
  },
  {
    investorType: 'Venture Capital',
    methodology: 'FCF Yield',
    count: 1,
    date: dateDayWeeksBefore(5, 5)
  },

  {
    investorType: 'Venture Capital',
    methodology: 'EV/Revenues',
    count: 1,
    date: dateDayWeeksBefore(4, 1)
  },
  {
    investorType: 'Venture Capital',
    methodology: 'EV/EBITDA',
    count: 1,
    date: dateDayWeeksBefore(4, 1)
  },
  {
    investorType: 'Mutual Fund',
    methodology: 'EV/EBITDA',
    count: 1,
    date: dateDayWeeksBefore(4, 1)
  },
  {
    investorType: 'Mutual Fund',
    methodology: 'FCF Yield',
    count: 2,
    date: dateDayWeeksBefore(4, 1)
  },
  {
    investorType: 'Mutual Fund',
    methodology: 'EV/Revenues',
    count: 2,
    date: dateDayWeeksBefore(4, 1)
  },
  {
    investorType: 'Mutual Fund',
    methodology: 'EV/EBITA',
    count: 1,
    date: dateDayWeeksBefore(4, 1)
  },

  {
    investorType: 'Venture Capital',
    methodology: 'EV/Revenues',
    count: 1,
    date: dateDayWeeksBefore(4, 5)
  },
  {
    investorType: 'Venture Capital',
    methodology: 'FCF Yield',
    count: 1,
    date: dateDayWeeksBefore(4, 5)
  },

  {
    investorType: 'Venture Capital',
    methodology: 'EV/EBITDA',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'Venture Capital',
    methodology: 'DCF',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'PE',
    methodology: 'EV/EBITDA',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'PE',
    methodology: 'EV/Revenues',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'Pension Fund',
    methodology: 'EV/Revenues',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'Pension Fund',
    methodology: 'EV/EBITDA',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'Pension Fund',
    methodology: 'FCF Yield',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'Pension Fund',
    methodology: 'DCF',
    count: 2,
    date: dateDayWeeksBefore(3, 1)
  },

  {
    investorType: 'Venture Capital',
    methodology: 'EV/EBITA',
    count: 1,
    date: dateDayWeeksBefore(3, 2)
  },
  {
    investorType: 'PE',
    methodology: 'EV/EBITA',
    count: 1,
    date: dateDayWeeksBefore(3, 2)
  },
  {
    investorType: 'SWF',
    methodology: 'EV/EBITA',
    count: 1,
    date: dateDayWeeksBefore(3, 2)
  },
  {
    investorType: 'Mutual Fund',
    methodology: 'EV/EBITA',
    count: 1,
    date: dateDayWeeksBefore(3, 2)
  },
  {
    investorType: 'Pension Fund',
    methodology: 'EV/EBITA',
    count: 1,
    date: dateDayWeeksBefore(3, 2)
  },
  {
    investorType: 'Hedge Fund',
    methodology: 'EV/EBITA',
    count: 1,
    date: dateDayWeeksBefore(3, 2)
  },
  {
    investorType: 'Corporate',
    methodology: 'EV/EBITA',
    count: 1,
    date: dateDayWeeksBefore(3, 2)
  },
  {
    investorType: 'Holding Company',
    methodology: 'EV/EBITA',
    count: 1,
    date: dateDayWeeksBefore(3, 2)
  },

  {
    investorType: 'Venture Capital',
    methodology: 'EV/Revenues',
    count: 1,
    date: dateDayWeeksBefore(3, 5)
  },
  {
    investorType: 'Venture Capital',
    methodology: 'EV/EBITDA',
    count: 1,
    date: dateDayWeeksBefore(3, 5)
  },
  {
    investorType: 'Venture Capital',
    methodology: 'FCF Yield',
    count: 2,
    date: dateDayWeeksBefore(3, 5)
  },
  {
    investorType: 'PE',
    methodology: 'EV/Revenues',
    count: 1,
    date: dateDayWeeksBefore(3, 5)
  },
  {
    investorType: 'PE',
    methodology: 'DCF',
    count: 1,
    date: dateDayWeeksBefore(3, 5)
  },

  {
    investorType: 'Mutual Fund',
    methodology: 'EV/EBITDA',
    count: 1,
    date: dateDayWeeksBefore(2, 2)
  },
  {
    investorType: 'Mutual Fund',
    methodology: 'FCF Yield',
    count: 1,
    date: dateDayWeeksBefore(2, 2)
  },
  {
    investorType: 'Mutual Fund',
    methodology: 'DCF',
    count: 1,
    date: dateDayWeeksBefore(2, 2)
  },

  {
    investorType: 'Venture Capital',
    methodology: 'EV/EBITDA',
    count: 1,
    date: dateDayWeeksBefore(2, 3)
  },
  {
    investorType: 'Venture Capital',
    methodology: 'FCF Yield',
    count: 1,
    date: dateDayWeeksBefore(2, 3)
  },
  {
    investorType: 'PE',
    methodology: 'FCF Yield',
    count: 1,
    date: dateDayWeeksBefore(2, 3)
  },
  {
    investorType: 'PE',
    methodology: 'DCF',
    count: 1,
    date: dateDayWeeksBefore(2, 3)
  },

  {
    investorType: 'SWF',
    methodology: 'EV/Revenues',
    count: 1,
    date: dateDayWeeksBefore(2, 5)
  },
  {
    investorType: 'SWF',
    methodology: 'EV/EBITDA',
    count: 1,
    date: dateDayWeeksBefore(2, 5)
  },
  {
    investorType: 'SWF',
    methodology: 'DCF',
    count: 1,
    date: dateDayWeeksBefore(2, 5)
  },
  {
    investorType: 'Mutual Fund',
    methodology: 'EV/EBITDA',
    count: 1,
    date: dateDayWeeksBefore(2, 5)
  },
  {
    investorType: 'Mutual Fund',
    methodology: 'DCF',
    count: 1,
    date: dateDayWeeksBefore(2, 5)
  },

  {
    investorType: 'Hedge Fund',
    methodology: 'EV/Revenues',
    count: 1,
    date: dateDayWeeksBefore(1, 3)
  },
  {
    investorType: 'Hedge Fund',
    methodology: 'FCF Yield',
    count: 1,
    date: dateDayWeeksBefore(1, 3)
  },
  {
    investorType: 'Hedge Fund',
    methodology: 'DCF',
    count: 1,
    date: dateDayWeeksBefore(1, 3)
  },

  {
    investorType: 'Venture Capital',
    methodology: 'EV/Revenues',
    count: 2,
    date: dateDayWeeksBefore(1, 4)
  },
  {
    investorType: 'Venture Capital',
    methodology: 'EV/EBITDA',
    count: 1,
    date: dateDayWeeksBefore(1, 4)
  },
  {
    investorType: 'Venture Capital',
    methodology: 'DCF',
    count: 2,
    date: dateDayWeeksBefore(1, 4)
  },
  {
    investorType: 'Mutual Fund',
    methodology: 'EV/Revenues',
    count: 1,
    date: dateDayWeeksBefore(1, 4)
  },
  {
    investorType: 'Mutual Fund',
    methodology: 'EV/EBITDA',
    count: 1,
    date: dateDayWeeksBefore(1, 4)
  },
  {
    investorType: 'Mutual Fund',
    methodology: 'DCF',
    count: 2,
    date: dateDayWeeksBefore(1, 4)
  },

  {
    investorType: 'Corporate',
    methodology: 'EV/EBITDA',
    count: 1,
    date: dateDayWeeksBefore(1, 5)
  },
  {
    investorType: 'Corporate',
    methodology: 'DCF',
    count: 1,
    date: dateDayWeeksBefore(1, 5)
  },
  {
    investorType: 'Holding Company',
    methodology: 'EV/Revenues',
    count: 1,
    date: dateDayWeeksBefore(1, 5)
  },
  {
    investorType: 'Holding Company',
    methodology: 'DCF',
    count: 1,
    date: dateDayWeeksBefore(1, 5)
  },

  {
    investorType: 'Pension Fund',
    methodology: 'DCF',
    count: 1,
    date: dateDayWeeksBefore(0, 0)
  },
  {
    investorType: 'Corporate',
    methodology: 'EV/Revenues',
    count: 1,
    date: dateDayWeeksBefore(0, 0)
  },
  {
    investorType: 'Corporate',
    methodology: 'EV/EBITDA',
    count: 1,
    date: dateDayWeeksBefore(0, 0)
  },
  {
    investorType: 'Corporate',
    methodology: 'DCF',
    count: 1,
    date: dateDayWeeksBefore(0, 0)
  }
];

export default dataMethodologies;
